import { Navigate, useLocation } from "react-router-dom";
import { ChildProps } from "../../interfaces/app_types";
import { useAuth } from "../../context/AuthProvider";

const ProtectedRoute = ({ children }: ChildProps) => {
  const location = useLocation();
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return "Loading";
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
